<app-template-page [forPrint]="true" (print)="print()"> </app-template-page>
